import React from 'react'
import {  TranslateExt } from '../contexts/LanguageContext';

export const Validator = {

    Valid(data, ref = null) {

        let error = Object.entries(data).length === 0 ? { error: true, message: "Invalid entries" } : { error: false, message: "" };

        try {
            Object.keys(data).forEach(function (key) {
                let validator = Validator.Rules[key];

                if (validator.Invalid(data[key])) {

                    error = {
                        error: true,
                        message: validator.Message
                    }

                    if (ref !== null)
                        ref.current.elements[key].focus();

                    throw new Error()
                }

            })
        }
        catch { }

        return error;


    },
    Rules: {
        AccountLogin: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value) || Validator.Conditions.Numeric(value);
            },
            Message: "Invalid Login ID"
        },
        Password: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Password can not be empty."
        },
        Email: {
            Invalid: (value) => {
                return !(/[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/.test(value))
            },
            Message: "Invalid Email Address."
        },
        amount: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value) || value <= 0 || Validator.Conditions.Numeric(value);
            },
            Message: "Invalid amount."
        },
        fromAccount: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select From Account!"
        },
        toAccount: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select Account!"
        },
        accountID: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Account ID!"
        },
        secureID: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Secure ID!"
        },
        bankCode: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select Bank!"
        },
        currency: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select Currency!"
        },
        bankAccount: {
            Invalid: (value) => {
                return Validator.Conditions.RequiredSelect(value);
            },
            Message: "Please select Bank Account!"
        },
        beneficiaryName: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Beneficiary Name!"
        },
        beneficiaryAccountNumber: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Beneficiary Account Number!"
        },
        bankName: {
            Invalid: (value) => {
                return Validator.Conditions.RequiredSelect(value);
            },
            Message: "Please enter your Bank Name!"
        },
        bankBranch: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Bank Branch!"
        },
        province: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Province!"
        },
        city: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your City!"
        }
    },
    Conditions: {
        Required(value) {
            return (value === null || value === "" || value === undefined);
        },
        RequiredSelect(value) {
            return (value === null || value === "" || value === undefined || value === "-1");
        },
        Max(value, max) {
            return (value > max);
        },
        Min(value, min) {
            return (value < min);
        },
        Numeric(value) {
            return isNaN(value);
        },
        MaxLength(value, length) {
            return (value.toString().length > length)
        },
        MinLength(value, length) {
            return (value.toString().length < length)
        }
    }


}

export const ErrorMessage = (props) => (
            <div className={"col-md-12 " + (props.Validation.error ? "" : "d-none")}>
                <div className={"alert alert-danger alert-dismissible fade mb-0 show " + (props.className || "")} role="alert">
                    <strong>Error !</strong> {TranslateExt(props.Validation.message)}
                </div>
            </div>
);

export const VRules = (Validator.Rules);
export const VConditions = (Validator.Conditions);
